/**
 * Persistence layer with expiration based on localStorage.
 */

const storageMock = {
  length: 0,
  getItem() {},
  setItem() {},
  removeItem() {},
  clear() {},
};

class NamespacedLocalStorage {
  constructor(localStorage, key) {
    this.localStorage = localStorage;
    this.key = key;
  }

  _makeKey(key) {
    return `${this.key}__${key}`;
  }

  getItem(name) {
    try {
      return this.localStorage.getItem(this._makeKey(name));
    } catch (error) {
      return null;
    }
  }

  setItem(name, value) {
    try {
      this.localStorage.setItem(this._makeKey(name), value);
    } catch (error) {
      console.error(error);
    }
  }

  removeItem(name) {
    try {
      this.localStorage.removeItem(this._makeKey(name));
    } catch (error) {
      console.error(error);
    }
  }
}

export default class BrowserPersistence {
  static KEY = 'HISEA_SSR_US';

  /* istanbul ignore next: test injects localstorage mock */
  constructor(localStorage = globalThis.localStorage || storageMock) {
    this.storage = new NamespacedLocalStorage(localStorage, this.constructor.KEY || BrowserPersistence.KEY);
  }

  getRawItem(name) {
    return this.storage.getItem(name);
  }

  getItem(name) {
    const now = Date.now();
    const item = this.storage.getItem(name);

    if (!item) {
      return undefined;
    }

    try {
      const { value, ttl, timeStored } = JSON.parse(item);

      if (ttl && now - timeStored > ttl * 1000) {
        this.storage.removeItem(name);

        return undefined;
      }

      // Check if value is defined before parsing
      return value !== undefined ? JSON.parse(value) : undefined;
    } catch (error) {
      // If parsing fails, remove the corrupted item
      console.error(`Failed to parse stored item "${name}":`, error);
      this.storage.removeItem(name);

      return undefined;
    }
  }

  setItem(name, value, ttl) {
    const timeStored = Date.now();

    this.storage.setItem(
      name,
      JSON.stringify({
        value: JSON.stringify(value),
        timeStored,
        ttl,
      }),
    );
  }

  removeItem(name) {
    this.storage.removeItem(name);
  }

  clearAll() {
    try {
      // this.storage.clear()
      localStorage.clear();
    } catch (error) {
      console.error(error);
    }
  }
}
